<!-- min height so there is no flickering between DLI and noDli -->
<p-message severity="info" styleClass="min-h-[58pt] p-0 flex items-center">
    @if (doc()) {
        <div
            class="flex flex-row w-full items-center justify-center gap-[3rem] md:gap-[5rem]"
            *ngIf="hasSelection(); else noDli"
        >
            <div
                class="flex flex-col"
                *ngIf="isSingleSelection() && dli()?.product?.productType == 'STORE'"
            >
                <div class="">
                    <app-storage-quantity-info-dli-statusbar
                        [dli]="dli()"
                        [doc]="doc()"
                        [stockDataArrayInput]="stockDataArrayInput()"
                        [(liveChangesCurrentWarehouse)]="liveChangesCurrentWarehouse"
                    ></app-storage-quantity-info-dli-statusbar>
                </div>
            </div>
            <!-- REVENUE -->
            <div class="flex flex-col text-center">
                <span class="flex flex-col items-center">
                    <span class="text-xs">{{ 'document-line-item.revenue' | translate }}:</span>
                    @if (aggregatedRevenue() != null) {
                        <span
                            [ngClass]="{
                                'text-success': aggregatedRevenue() && aggregatedRevenue() >= 0,
                                'text-red-700': aggregatedRevenue() && aggregatedRevenue() < 0,
                                'text-muted-color': aggregatedRevenue() == 0
                            }"
                            class="font-bold"
                            >{{
                                aggregatedRevenue() | decimalPlacesCustom: decimalPlacesInputSettings
                            }}&nbsp;{{ doc().currency
                            }}{{
                                revenuePercent() !== null
                                    ? ' (' + (revenuePercent() | number: '1.2-2') + '%)'
                                    : ''
                            }}</span
                        >
                    } @else {
                        <ng-container *ngTemplateOutlet="notAvailable"></ng-container>
                    }
                </span>
            </div>
            <!-- ITEM PRICE ORIGIN -->
            <div class="flex flex-col text-center">
                <span class="flex flex-col items-center">
                    <span class="text-xs"
                        >{{ 'document-line-item.price-origin' | translate }}:</span
                    >
                    <span
                        *ngIf="priceOriginLabel(); else notAvailable"
                        [class]="isManualPriceOrigin() ? 'text-orange-400' : ''"
                    >
                        {{ priceOriginLabel() }}
                    </span>
                </span>
            </div>
        </div>

        <ng-template #noDli>
            <div class="flex justify-center items-center w-full">
                <span class="text-muted-color italic">{{
                    'document.no-document-line-item-selected' | translate
                }}</span>
            </div>
        </ng-template>

        <ng-template #notAvailable>
            <span class="text-muted-color italic">{{ 'common.not-available' | translate }}</span>
        </ng-template>
    }
</p-message>
